import React from 'react';

import { Container } from 'components/Payment/PaymentCardItem/styles';
import Shimmer from 'components/Shimmer';

import { Header } from './styles';

const PaymentCardItemSkeleton = () => (
  <Container>
    <Header>
      <Header.Icon>
        <Shimmer width="100%" height="100%" />
      </Header.Icon>
      <Header.Detail>
        <div>
          <Header.Title>
            <Shimmer>MASTER *12345</Shimmer>
          </Header.Title>
          <Shimmer>01 / 2022</Shimmer>
        </div>
      </Header.Detail>
      <Header.ArrowIcon empty />
    </Header>
  </Container>
);

export default PaymentCardItemSkeleton;
